import { render, staticRenderFns } from "./AddNewPreReceiveWarehouse.vue?vue&type=template&id=6f6eff6a"
import script from "./AddNewPreReceiveWarehouse.vue?vue&type=script&lang=js"
export * from "./AddNewPreReceiveWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports